var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.allRules,"counter":10,"label":_vm.label || _vm.$t('telephone_number'),"hint":_vm.msisdn},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}})}
var staticRenderFns = []

export { render, staticRenderFns }